import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - scrolls window to top on route change
 * This ensures users start at the top of each page when navigating
 * Uses instant scroll (no smooth animation) for better UX
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's scroll restoration so we can control it
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    // Force immediate scroll to top - no animation
    // Using behavior: 'auto' combined with style override to ensure instant scroll
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Restore scroll behavior after a brief delay to ensure the jump happened
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = '';
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

